<template>
  <div>
    <v-card :disabled="isProcessing" :loading="isProcessing">
      <template v-slot:progress>
        <v-progress-linear absolute color="success" height="4" indeterminate></v-progress-linear>
      </template>
      <v-tabs v-model="tab" class="deep-gl" left dark icons-and-text>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
          <v-toolbar-title>{{ $t("USERS.VIEW") }}</v-toolbar-title>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item value="tab-1">
          <v-card flat>
            <v-card-text>
              <div class="preview-list">
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.ID") }}:</span>
                  <span class="preview-value">{{ requestData.id || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.NAME") }}:</span>
                  <span class="preview-value">{{ requestData.name || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.EMAIL") }}:</span>
                  <span class="preview-value">{{ requestData.email || "-" }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("GENERAL.LABELS.STATUS") }}:</span>
                  <span class="preview-value">
                    <v-chip x-small :color="requestData.active ? 'success' : 'error'" dark>
                      {{ requestData.active ? $t("GENERAL.LABELS.ACTIVE") : $t("GENERAL.LABELS.INACTIVE") }}
                    </v-chip>
                  </span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("USERS.LABELS.GOOGLE_LOGIN") }}:</span>
                  <span class="preview-value">{{ googleLogin ? $t("INCOTERMS.YES") : $t("INCOTERMS.NO") }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("MENU.ASIDE.TEAMS") }}:</span>
                  <span class="preview-value">{{ teamsLabel }}</span>
                </div>
                <div class="preview-row">
                  <span class="preview-label">{{ $t("USERS.SYSTEM_ADMIN") }}:</span>
                  <span class="preview-value">{{ requestData.is_admin ? $t("INCOTERMS.YES") : $t("INCOTERMS.NO") }}</span>
                </div>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="hasPermissions('users-edit')"
                color="primary"
                class="mr-2"
                :to="{ name: 'edit-user', params: { id: requestData.id || $route.params.id } }"
              >
                {{ $t("GENERAL.LABELS.EDIT_BUTTON") }}
              </v-btn>
              <v-btn color="warning" @click="back">{{ $t("GENERAL.LABELS.BACK_BUTTON") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { GET_USER_REQUEST } from "@/store/users.module";
import { SHOW_SNACK } from "@/store/snack.module";

export default {
  name: "ViewUser",
  data() {
    return {
      tab: "tab-1",
      isProcessing: false,
      requestData: {},
    };
  },
  computed: {
    googleLogin() {
      const types = this.requestData.login_types || [];
      return Array.isArray(types) && types.includes("google");
    },
    teamsLabel() {
      const teams = this.requestData.teams;
      if (!Array.isArray(teams) || !teams.length) {
        return "-";
      }

      return teams
        .map((team) => team.name)
        .filter(Boolean)
        .join(", ") || "-";
    },
  },
  mounted() {
    this.loadUser();
  },
  methods: {
    back() {
      this.$router.push({ name: "users" });
    },
    loadUser() {
      this.isProcessing = true;
      this.$store
        .dispatch(GET_USER_REQUEST, this.$route.params.id)
        .then((response) => {
          this.requestData = response || {};
        })
        .catch(() => {
          this.$store.dispatch(SHOW_SNACK, {
            message: this.$t("GENERAL.UNEXPECTED_ERROR"),
            type: "error",
          });
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
